import { render, staticRenderFns } from "./block-insured-insured.vue?vue&type=template&id=5bf98215&scoped=true"
import script from "./block-insured-insured.vue?vue&type=script&lang=js"
export * from "./block-insured-insured.vue?vue&type=script&lang=js"
import style0 from "./block-insured-insured.vue?vue&type=style&index=0&id=5bf98215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf98215",
  null
  
)

export default component.exports